const ProdToProbAnim = (el) => {
  const mm = gsap.matchMedia();
  let tl;

  mm.add("(min-width: 768px)", () => {
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: el, // The element that starts the scroll effect
        start: "top 50%", // When the top of the container hits the top of the viewport
        end: "=25%", // Scroll 2000px before releasing the pin
        scrub: 1, // Smoothly catches up to the scrollbar over 1 second
        // markers: true, // Enable markers for debugging
      },
      defaults: {
        duration: 1,
        ease: "power2.inOut",
      },
    });

    tl.add("anim", 0);

    tl.from(
      el.querySelector(".arrow-container"),
      { duration: 3, width: 0 },
      "anim+=0",
    );

    tl.from(".arrow-container img", { duration: 0.3, opacity: 0 }, "anim+=1");

    const pillars = [...el.querySelectorAll(".pillar")];
    pillars.forEach((pillar, index) => {
      tl.from(
        pillar.children,
        { duration: 1, y: "+50", opacity: 0, stagger: 0.4 },
        "anim+=" + index * 0.6,
      );
    });
  });

  mm.add("(max-width: 767px)", () => {
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: el, // The element that starts the scroll effect
        start: "top 50%", // When the top of the container hits the top of the viewport
        end: "=60%", // Scroll 2000px before releasing the pin
        scrub: 1, // Smoothly catches up to the scrollbar over 1 second
        // markers: true, // Enable markers for debugging
      },
      defaults: {
        duration: 1,
        ease: "power2.inOut",
      },
    });

    tl.add("anim", 0);

    tl.from(
      el.querySelector(".arrow-container"),
      { duration: 3, height: 0 },
      "anim+=0",
    );

    tl.from(".arrow-container img", { duration: 0.3, opacity: 0 }, "anim+=1.2");

    const pillars = [...el.querySelectorAll(".pillar")];
    pillars.forEach((pillar, index) => {
      tl.from(
        pillar.children,
        { duration: 1, y: "+10", opacity: 0, stagger: 0.2 },
        "anim+=" + index * 0.6,
      );
    });
  });
};

export default ProdToProbAnim;
